import { getRankIndex, sortCardsByRank } from '../card';
import { RANK_ORDER_STANDARD } from '../constants';
import { Rank } from '../enums';
import { Card, Entry } from '../types';

export { getRankIndex };

export function compareEntries(a: Entry, b: Entry): number {
  return a.index - b.index;
}

export function getRankCounts(cards: readonly Card[]): Map<Rank, number> {
  const counts = new Map<Rank, number>();
  for (const card of cards) {
    counts.set(card.rank, (counts.get(card.rank) || 0) + 1);
  }
  return counts;
}

export function isFlush(cards: readonly Card[]): boolean {
  if (cards.length === 0) return false;
  const suit = cards[0].suit;
  return cards.every((c) => c.suit === suit);
}

export function isStraight(cards: readonly Card[], rankOrder: readonly Rank[] = RANK_ORDER_STANDARD): boolean {
  if (cards.length < 2) return cards.length === 1;

  const indices = cards.map((c) => getRankIndex(c.rank, rankOrder)).sort((a, b) => a - b);

  for (let i = 1; i < indices.length; i++) {
    if (indices[i] !== indices[i - 1] + 1) {
      if (i === indices.length - 1 && isWheelStraight(cards)) {
        return true;
      }
      return false;
    }
  }
  return true;
}

export function isWheelStraight(cards: readonly Card[]): boolean {
  if (cards.length !== 5) return false;

  const ranks = new Set(cards.map((c) => c.rank));
  return (
    ranks.has(Rank.ACE) && ranks.has(Rank.DEUCE) && ranks.has(Rank.TREY) && ranks.has(Rank.FOUR) && ranks.has(Rank.FIVE)
  );
}

export function getHighCardRanks(cards: readonly Card[], rankOrder: readonly Rank[] = RANK_ORDER_STANDARD): Rank[] {
  return sortCardsByRank(cards, rankOrder).map((c) => c.rank);
}

export function buildStrengthIndex(
  handTypeBase: number,
  kickers: Rank[],
  rankOrder: readonly Rank[] = RANK_ORDER_STANDARD,
): number {
  let index = handTypeBase;
  for (let i = 0; i < kickers.length; i++) {
    index = index * 13 + getRankIndex(kickers[i], rankOrder);
  }
  return index;
}
